import { Link, useNavigate } from "react-router-dom";
import LibasLogo from "../../assets/images/navbar/Libas-logo1.png";
import googleplay from "../../assets/images/navbar/googleplay.png";
import x from "../../assets/images/X.png";
import { AiOutlineClose } from "react-icons/ai";
import { Accordion, Collapse, Modal } from "react-bootstrap";
import Search from "../../assets/images/Search.png";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useState } from "react";
import {
  GetCurrency,
  SelectedCurrencies,
  GetCurrencyDefault,
} from "../../features/Currency/CurrencySlice";
import {
  db,
  collection,
  onSnapshot,
  query,
  where,
  getFirebaseToken,
  updateDoc,
  orderBy,
  doc,
} from "../../utils/firebase/firebase.utils";
import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  SetSizeFilter,
  SetTopSizeFilter,
  resetLoadingNumber,
  SetSignUpp,
  SetSignIn,
} from "../../features/Products/ProductSlice";
import { GetAllProductViewd } from "../../features/RecentlyViewed/RecentlyViewed";
import { SetSearch } from "../../features/TopSearches/TopSearchesSlice";
import branch from "branch-sdk";
import { NOTIFICATION_TYPE_PRODUCT_PRICE_DROP } from "../../constants/constants";
import { useTranslation } from "react-i18next";
import { FillMybags } from "../../features/Bag/MybagSlice";
import { GetBalances } from "../../features/Flags/FlagsSlice";
import LibasMenu from "../../LibasMenu";
import { UserContext } from "../../context/user.context";

function NavBarMdal({
  show,
  setShow,
  selectedcurrency,
  setSignIn,
  setSignUp,
  users,
  logoProf,
  currencies,
  handleChange,
  currencydefault,
  signOutUser,
  ShoppingBag,

  notifications,
  setShowNotification,
}) {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { currentUser, setShowSearchh } = useContext(UserContext);
  const handleClose = () => {
    setShow(false);
  };
  const { constant } = useSelector((store) => store.flags);
  const languages = JSON.parse(localStorage.getItem("language"));
  const handleCheckLanguage = (e) => {
    localStorage.setItem("language", e);
    if (e == true) {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("ar");
    }
  };
  const handleCheck = (e) => {
    setChecked(e);

    if (e) {
      dispatch(SelectedCurrencies("1YiC1Sz9MkYPY3LG8MlN"));
    } else {
      dispatch(SelectedCurrencies("papAwH0XoKC3AmT9YmR7"));
    }
  };
  function OpenedNotification() {
    if (
      currentUser &&
      notifications.filter(
        (notf) =>
          notf.toUid == currentUser.uid &&
          notf.isOpened == false &&
          notf.type != NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
      ).length != 0
    ) {
      {
        notifications
          .filter(
            (notf) =>
              notf.toUid == currentUser.uid &&
              notf.isOpened == false &&
              notf.type != NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
          )
          .map((notf) =>
            updateDoc(
              doc(db, "notifications", notf.id),

              { isOpened: true }
            )
          );
      }
    }
  }
  function ShopAll() {
    dispatch(GetProductJustViewdd([]));
    dispatch(GetProductAlsoLike([]));
    dispatch(GetProductFromSeller([]));
    dispatch(GetProductNewDrops([]));
    dispatch(GetProductTopPicks([]));
    dispatch(GetAllProductViewd([]));
    dispatch(GetLibasProduct([]));
    dispatch(GetAllProductVintage([]));
    dispatch(GetAllChanel([]));
    dispatch(GetAllAmina([]));
    dispatch(GetAllPradaReEdition([]));
    dispatch(GetAllChanelBoy([]));
    dispatch(GetAllBottega([]));
    dispatch(GetAllHermes([]));
    dispatch(GetAllBirkin([]));
    dispatch(GetAllBurberry([]));
    dispatch(IsBurberry(false));

    dispatch(GetAllDG([]));
    dispatch(IsDG(false));

    dispatch(GetAllLV([]));
    dispatch(IsLV(false));

    dispatch(GetAllDisel([]));
    dispatch(IsDisel(false));

    dispatch(GetAllGucci([]));
    dispatch(IsGucci(false));

    dispatch(GetAllMM([]));
    dispatch(IsMM(false));

    dispatch(GetAllZadig([]));
    dispatch(IsZadug(false));
    dispatch(IsJustView(false));
    dispatch(IsDrops(false));
    dispatch(IsTopPicks(false));
    dispatch(IsProductFromSeller(false));
    dispatch(IsProductAlsoLike(false));
    dispatch(IsProductLibas(false));
    dispatch(IsVintage(false));
    dispatch(IsChanel(false));
    dispatch(IsAmina(false));
    dispatch(IsPradaReEdition(false));
    dispatch(IsChanelBoy(false));
    dispatch(IsBottega(false));
    dispatch(IsHermes(false));
    dispatch(IsBirkin(false));
  }
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  const [openSection, setOpenSection] = useState("");

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? "" : section);
  };

  return (
    <>
      <div className="modal-header justify-content-end d-flex pb-0">
        <button
          type="button"
          className="close close-txt close-modal align-items-center px-0"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setShow(false)}
        >
          <img
            src={x}
            alt="main"
            onClick={() => setShow(false)}
            className="x-close ms-1 mb-1"
          />
        </button>
      </div>

      <div className="modal-body">
        <div className="position-relative">
          <div
            className={`modal ${show ? "show" : ""}`}
            style={{ display: show ? "block" : "none" }}
          >
            <div className="modal-dialog modal-fullscreen m-0">
              <div className="modal-content">
                <LibasMenu
                  currentUser={currentUser}
                  setShow={setShowSearchh}
                  constant={constant}
                  ShopAll={ShopAll}
                  setSignIn={setSignIn}
                  signOutUser={signOutUser}
                  arabStyle={arabStyle}
                  i18n={i18n}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavBarMdal;
